//components
import { FC } from 'react';
import { CustomList as List } from '../custom-list';

//syles
import styles from './shortcutLinks.module.scss';
import { CMSData } from '@/types/cmsData';

interface IShortcutLinksProps {
  shortCutLinks?: CMSData;
  shopCustomerService?: CMSData;
}

const ShortcutLinks: FC<IShortcutLinksProps> = ({ shortCutLinks, shopCustomerService }) => (
  <div className={styles.shortcutLinks} data-testid="shortcutLinks">
    <div className={styles.bbLinks} data-testid="bbLinks">
      <List linkCategory={shortCutLinks} />
    </div>
    <div className={styles.csLinks} data-testid="csLinks">
      <List linkCategory={shopCustomerService} />
    </div>
  </div>
);

export default ShortcutLinks;
